module.exports = __webpack_public_path__ + "img/jacket-back-sub-setIn-classic.cf9a6735.png";